import React from 'react';
import PropTypes from 'prop-types';

import { Section } from '../Section';
import { Checkbox } from './styles';

export const DefaultValuesSection = ({
	hideDecimals,
	animationIndex,
	onChange,
}) => {
	return (
		<Section
			title="Hide Decimals in Spend Amount"
			animationIndex={animationIndex}
		>
			<Checkbox
				checked={hideDecimals}
				onChange={event => onChange({ hideDecimals: event.target.checked })}
			>
				Hide
			</Checkbox>
		</Section>
	);
};

DefaultValuesSection.propTypes = {
	hideDecimals: PropTypes.bool.isRequired,
	animationIndex: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired,
};
